import React from 'react';
import { InsightsForm } from './InsightsForm';

export function InsightsUnavailable() {
  return (
    <>
      <InsightsForm />
      <img
        src={require(`assets/images/blurred_insights.png`)}
        alt="insights"
        style={{ width: '100vw' }}
      />
    </>
  );
}
